import { Injectable } from '@angular/core';
import { ThemeVariant, themeSwitcher } from '@siemens/ix';

const THEME_STORAGE_KEY = 'app-theme-variant';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly defaultVariant: ThemeVariant = 'dark';
  private currentVariant: ThemeVariant = this.getStoredVariant();

  constructor() {
    this.applyTheme(this.currentVariant);
  }

  public get isDarkMode(): boolean {
    return this.currentVariant === 'dark';
  }

  public toggleTheme(isDarkMode: boolean): void {
    this.currentVariant = isDarkMode ? 'dark' : 'light';
    this.applyTheme(this.currentVariant);
    localStorage.setItem(THEME_STORAGE_KEY, this.currentVariant);
  }

  private applyTheme(variant: ThemeVariant): void {
    themeSwitcher.setTheme(`theme-classic-${variant}`);
    document.documentElement.setAttribute('data-ix-theme', 'classic');
    document.documentElement.setAttribute('data-ix-color-schema', variant);
  }

  private getStoredVariant(): ThemeVariant {
    const storedVariant = localStorage.getItem(THEME_STORAGE_KEY);
    return storedVariant === 'light' || storedVariant === 'dark' ? storedVariant : this.defaultVariant;
  }
}